export default __webpack_public_path__ + "static/media/jcb.23549291.svg";